import { useEffect, useState } from "react";
import { Delete } from "lucide-react";

export const PinPad = ({ onComplete, error, busy }) => {
  const [pin, setPin] = useState("");

  useEffect(() => { if (error) setPin(""); }, [error]);

  const press = (d) => {
    if (busy || pin.length >= 4) return;
    const next = pin + d;
    setPin(next);
    if (next.length === 4) onComplete(next);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (/^\d$/.test(e.key)) press(e.key);
      if (e.key === "Backspace") setPin((p) => p.slice(0, -1));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  return (
    <div data-testid="pin-pad" className="flex flex-col items-center gap-5">
      <div className="flex gap-3" data-testid="pin-dots">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`w-5 h-5 rounded-full border-[3px] border-[#1B1A2E] transition-colors ${i < pin.length ? "bg-[#7B5CFA]" : "bg-white"}`} />
        ))}
      </div>
      {error && <p data-testid="pin-error" className="text-[#E8442A] font-semibold text-sm">{error}</p>}
      <div className="grid grid-cols-3 gap-3">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
          <PinKey key={d} d={d} onClick={() => press(d)} />
        ))}
        <span />
        <PinKey d="0" onClick={() => press("0")} />
        <button data-testid="pin-backspace" onClick={() => setPin((p) => p.slice(0, -1))} className="w-16 h-16 rounded-2xl grid place-items-center hover:bg-[#FFF7EC] transition-colors">
          <Delete />
        </button>
      </div>
    </div>
  );
};

const PinKey = ({ d, onClick }) => (
  <button data-testid={`pin-digit-${d}`} onClick={onClick} className="zn-btn !px-0 !py-0 w-16 h-16 !rounded-2xl bg-white text-2xl">
    {d}
  </button>
);
